import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Accordion as SemanticUiAccordion } from 'semantic-ui-react';
import Content from './components/Content/Content';
import useSemanticUiProps from '../../hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../types/component';
var defaultProps = {};
export default function Accordion(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getAccordionProps = _useSemanticUiProps.getAccordionProps;
  return /*#__PURE__*/React.createElement(SemanticUiAccordion, getAccordionProps(props), children);
}
Accordion.defaultProps = defaultProps;
Accordion.Content = Content;
Accordion.Panel = SemanticUiAccordion.Panel;
Accordion.Title = SemanticUiAccordion.Title;
Accordion.Accordion = SemanticUiAccordion.Accordion;